const app_modules = {
  dashboard: {
    app_name: "Dashboard",
    modules: {
      dashboard: "Dashboard",
    },
  },
  user_management: {
    app_name: "User Management",
    modules: {
      user_management: "User Management",
      organisation: "Organisation",
      department: "Department",
      team: "Team",
      user: "User",
      user_types: "User Types",
      module: "Module",
    },
  },
  master: {
    app_name: "Masters",
    modules: {
      master: "Master",
      category: "Category",
      subcategory: "Sub Category",
      item: "Item",
      unit: "Unit",
      gst: "GST",
      hsn_code: "HSN Code",
      suppliers: "Suppliers",
      warehouse: "Warehouse",
      labour: "Labour",
      customer: "Customer",
    },
  },
  warehouse: {
    
    app_name: "Warehouse",
    modules: {
      warehouse: "warehouse",
      warehouse_overview: "Warehouse Overview",
      item_inward: "Item Inward",
      dispatch: "Dispatch",
    },
  },
  inventory: {
    app_name: "Inventory",
    modules: {
      inventory: "Inventory",
      in_stock: "In Stock",
      dispatch: "Dispatch",
      reorder_level: "Reorder Level",
      order:"Order"
    },
  },
  order: {
    app_name: "Order",
    modules: {
      enquiry: "Enquiry",
      quotation: "Quotation",
      site_visit: "Site Visit",
      order: "Order",
    },
  },
};
const action_options = {
  create: "Create",
  view: "View",
  update: "Update",
};

export { app_modules, action_options };
